/*
	在真实请求发出前执行，位于所有request拦截器之后
*/
import sign from './sign'
const handlers = [sign]
export default function finalInterceptor(config) {
  return handlers.reduce((final, item) => {
    return final.then(item)
  }, Promise.resolve(config))
}